export const deviceCodePattern = {
  trap: [/^trap;(?<version>\d+);(?<uid>[0-9a-fA-F]{16})$/],
  gateway: [
    /^gateway;(?<version>\d+);(?<uid>[0-9a-fA-F]{16})/,
    ...config.GATEWAY_ID_PREFIXES.map(
      (prefix) => new RegExp(`^(?<uid>${prefix}[0-9a-fA-F]{${Math.max(16 - prefix.length, 0)}})$`),
    ),
  ],
};

export default function parseCode(code: string) {
  for (const [deviceType, patterns] of Object.entries(deviceCodePattern))
    for (const pattern of patterns) {
      const match = pattern.exec(code);

      if (match) {
        const { version = '', uid = '' } = match.groups!;
        return {
          type: 'device',
          deviceType,
          version,
          uid: uid.toLowerCase(),
        } as const;
      }
    }

  return { type: 'unknown' } as const;
}
